import { NodeViewProps } from '@tiptap/core';
import { NodeViewWrapper } from '@tiptap/react';

import { cn } from '@/lib/utils';

import { useTemplateVariables } from '../context/TemplateContext';
import { ClientInjuryItem, MedicalListItem, TemplateVariableValue } from '../types';

const formatValueForDisplay = (
  value: TemplateVariableValue,
): string | null => {
  if (value === null || value === undefined) {
    return null;
  }
  if (Array.isArray(value)) {
    if (value.length === 0) {
      return null;
    }
    // Check if it's a MedicalListItem array or ClientInjuryItem array
    if ('name' in value[0]) {
      return (value as Array<MedicalListItem>).map((item) => `${item.name} - ${item.address}`).join('; ');
    }
    if ('bodyPart' in value[0]) {
      return (value as Array<ClientInjuryItem>).map((item) => `${item.bodyPart}: ${item.description}`).join('; ');
    }
    return null;
  }
  if (typeof value === 'object') {
    return JSON.stringify(value);
  }
  if (typeof value === 'string' && value.trim() === '') {
    return null;
  }
  return value;
};

export const TemplateNodeView = ({ node }: NodeViewProps) => {
  const { values } = useTemplateVariables();
  const variableName = node.attrs.id as string;
  const rawValue = values[variableName];
  const value = formatValueForDisplay(rawValue);
  const hasValue = value !== null;

  if (!hasValue) {
    return (
      <NodeViewWrapper
        as="span"
        className="rounded-xs break-words font-mono   inline-block leading-none align-bottom  px-0.5 border-red-600 border-b-2 bg-red-300"
      >
        [{variableName}]
      </NodeViewWrapper>
    );
  }

  return (
    <NodeViewWrapper
      as="span"
      className={cn(
        'rounded break-words inline-block align-bottom  bg-green-100',
      )}
    >
      <div className="flex flex-col items-left">
        <span className="text-[8px] text-gray-600 font-mono leading-none">
          {variableName}
        </span>
        <span>{value}</span>
      </div>
    </NodeViewWrapper>
  );
};
